export const noTags = (value) => {
	const regex = /(<([^>]+)>)/ig

	return typeof value === 'string' ? value.replace(regex, "").trim() : value;
};
